import React from 'react';

export default function IconID() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#C8414B"
                d="M32 11H0V1.069C0 .764.247.517.552.517h30.896c.305 0 .552.247.552.552V11Z"
            />
            <path
                fill="#F5F5F5"
                d="M0 11h32v9.931a.552.552 0 0 1-.552.552H.552A.552.552 0 0 1 0 20.93V11Z"
            />
        </svg>
    );
}
